import * as React from "react";
import { cn } from "../../lib/utils";

const Switch = React.forwardRef(
  ({ className, checked, defaultChecked, onCheckedChange, disabled, ...props }, ref) => {
    const [uncontrolled, setUncontrolled] = React.useState(!!defaultChecked);
    const isControlled = checked !== undefined;
    const isOn = isControlled ? !!checked : uncontrolled;
    const toggle = () => {
      if (disabled) return;
      const next = !isOn;
      if (!isControlled) setUncontrolled(next);
      if (onCheckedChange) onCheckedChange(next);
    };
    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={isOn}
        data-state={isOn ? "checked" : "unchecked"}
        disabled={disabled}
        onClick={toggle}
        className={cn(
          "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
          isOn ? "bg-primary" : "bg-input",
          className
        )}
        {...props}
      >
        <span
          className={cn(
            "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform",
            isOn ? "translate-x-5" : "translate-x-0"
          )}
        />
      </button>
    );
  }
);
Switch.displayName = "Switch";

export { Switch };
